import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { AccordionComponent } from '../../../../../ui/accordion/accordion.component';
import { AccordionItemComponent } from '../../../../../ui/accordion/item/accordion-item.component';
import { PAGE_COMPONENT_FAQ_CONFIG } from './faq.config';
import { NPageComponentFaqComponent } from './faq.interface';

let uid = 0;

export const pageComponentFaqUid = () => {
    return uid++;
};

@Component({
    selector: 'page-component-faq',
    templateUrl: './faq.component.html',
    standalone: true,
    imports: [AccordionComponent, AccordionItemComponent, ICmsClientModule],
    host: { ngSkipHydration: 'true' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentFaqComponent>(PAGE_COMPONENT_FAQ_CONFIG)
export class PageComponentFaqComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NPageComponentFaqComponent.IComponentData;

    readonly uid = `page-component-faq-${pageComponentFaqUid()}`;
}
